// These are temporary? until some real error codes manifest themselves to ticket-printer API?
export enum PrinterStatus {
  IDLE = "idle",
  PRINTING = "printing",
  ERROR_MALFUNCTION = "printer-malfunction-error",
}
